export default {
  computed: {
    requestStatus() {return this.$store.getters.requestStatus},
    myRequestStatus() {return this.requestStatus.find(f => f.name === `${this.rq_name}/a/all`)},
    filter() {
      if (!this.myRequestStatus) return null;
      return this.myRequestStatus.filter;
    },
  },
};
